import { Token, token } from 'styled-system/tokens';
import { ChartData } from 'chart.js';

export const homePageChartDataColor: Token[] = [
  'colors.green-3',
  'colors.orange-1',
  'colors.pink-1',
  'colors.blue-2',
  'colors.purple-3',
];

export const generateHomePageChartData: (
  dataChart: number[],
) => ChartData<'doughnut', number[], unknown> = (dataChart) => {
  if (
    dataChart.reduce(
      (previousValue, currentValue) => previousValue + currentValue,
      0,
    ) === 0
  ) {
    return {
      datasets: [
        {
          data: [1],
          backgroundColor: [token('colors.gray-1')],
        },
      ],
    };
  }
  return {
    datasets: [
      {
        data: dataChart,
        backgroundColor: homePageChartDataColor.map((item) => token(item)),
        borderColor: '#fff',
        borderWidth: 2,
        borderRadius: 3,
      },
    ],
  };
};
